<h5>{{ caption }}</h5>

<form>
  <div class="d-flex align-items-center flex-wrap mb-3">
    <div class="input-group">
      <input
        placeholder="Search Users"
        id="txtSearch"
        class="form-control form-control-sm"
        type="text"
        [formControl]="filter"
      />
      <button
        type="button"
        class="btn btn-sm btn-input-group"
        (click)="clearSearch()"
      >
        <fa-icon [icon]="icons.times"></fa-icon>
      </button>
    </div>
    <div>
      <a class="btn btn-link font-size-smaller" (click)="selectAll()"
        >Select All</a
      >
      |
      <a class="btn btn-link font-size-smaller" (click)="selectNone()"
        >Select None</a
      >
    </div>
  </div>
</form>

<div class="row row-cols-1 row-cols-md-2 row-cols-lg-3">
  @for (user of filteredUsers | async; track user; let i = $index) {
    <div class="col">
      <div class="form-check form-switch custom-switch-primary">
        <input
          #chkUser="ngModel"
          [(ngModel)]="user.IsSelected"
          type="checkbox"
          class="form-check-input"
          id="chkUser-{{ user.Id }}"
          name="chkUser-{{ user.Id }}"
        />
        <label class="form-check-label" for="chkUser-{{ user.Id }}">{{
          user.Name
        }}</label>
      </div>
    </div>
  }
</div>
